export default __webpack_public_path__ + "static/media/ui-performance-testing.ad6aadc9.svg";